import { Box, Container, Typography, Paper, Divider } from '@mui/material';

function PrivacyPage() {
  return (
    <Box className="page-shell">
      <Container maxWidth="md" className="page-wrap" sx={{ px: 0 }}>
        <Typography
          variant="h2"
          textAlign="center"
          sx={{ mb: 2, fontWeight: 700 }}
        >
          Privacy Policy
        </Typography>
        <Typography
          variant="body1"
          textAlign="center"
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          Gorty's Tech, LLC
        </Typography>

        <Paper sx={{ p: { xs: 3, md: 4 } }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            Last updated: January 2026
          </Typography>

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Information We Collect
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            We may collect the following information when you use our website or
            request our services:
          </Typography>
          <Box component="ul" sx={{ mb: 3, pl: 3 }}>
            <li>
              <Typography variant="body1">
                Name and contact information (email address, phone number)
              </Typography>
            </li>
            <li>
              <Typography variant="body1">Company name (if provided)</Typography>
            </li>
            <li>
              <Typography variant="body1">
                Information about your project or service needs
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                SMS consent preferences and phone numbers for text messaging
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                Technical information such as IP address and browser type
              </Typography>
            </li>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            How We Use Information
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            We use the information we collect to:
          </Typography>
          <Box component="ul" sx={{ mb: 3, pl: 3 }}>
            <li>
              <Typography variant="body1">
                Respond to service requests and inquiries
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                Schedule appointments and provide project updates
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                Provide customer support and communicate about our services
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                Send SMS messages to users who have opted in
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                Improve our website and services
              </Typography>
            </li>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            SMS / Mobile Information
          </Typography>
          <Box className="legal-callout" sx={{ mb: 3 }}>
            <Typography variant="body1" fontWeight={500}>
              Mobile information, including phone numbers and SMS opt-in consent,
              will not be shared with third parties or affiliates for marketing or
              promotional purposes.
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ mb: 3 }}>
            If you opt in to receive SMS messages from Gorty's Tech, LLC, we will
            use your phone number only to send you messages related to service
            requests, appointment scheduling, project updates, and customer
            support. You may opt out at any time by replying STOP to any message.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Data Sharing
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            We do not sell your personal information.
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            We do not sell SMS opt-in information or phone numbers.
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            We may share information with service providers who help us operate
            our business (such as hosting providers), but only as necessary to
            provide our services and subject to confidentiality obligations.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Data Retention
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            We retain personal information for as long as necessary to provide our
            services and fulfill the purposes described in this policy. Service
            request records may be retained for business and legal purposes.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Your Rights
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            You may contact us to request access to, correction of, or deletion of
            your personal information. We will respond to your request in a
            reasonable timeframe.
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
            Contact Us
          </Typography>
          <Typography variant="body1">
            If you have questions about this Privacy Policy or wish to request
            deletion of your information, please contact Gorty's Tech, LLC through
            our website's contact form or at the email address provided on our
            website.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default PrivacyPage;
